import React, { FC } from 'react'

import { useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { isString } from 'lodash'
import { useTranslation } from 'react-i18next'

import { ThemeIcon } from '../ThemeIcon'

import { EmptyTableProps } from './types'

export const EmptyTable: FC<EmptyTableProps> = ({ title, message, children, sx }) => {
  const { t } = useTranslation()
  const { palette, spacing } = useTheme()

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent={'center'}
      height={'100%'}
      flex={1}
      bgcolor={palette.background.paper}
      borderRadius={0.5}
      margin={spacing(2)}
      padding={spacing(2)}
      sx={sx}
    >
      <Box>
        <ThemeIcon name="trades" alt="Trades" />
      </Box>
      <Typography variant="h3" mt={5} textAlign={'center'}>
        {title || t('noTrades', 'No trades to show')}
      </Typography>
      {isString(message) && (
        <Typography
          variant="body1"
          fontWeight={500}
          mt={3}
          maxWidth={spacing(50)}
          align={'center'}
          textAlign={'center'}
        >
          {message}
        </Typography>
      )}
      {children}
    </Box>
  )
}
